/* Polsk katalog for locale-autopilot-year-end-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'ap.yearEnd.title': 'Zamknięcie roku {{year}}',
  'ap.yearEnd.progress': 'Postęp zamknięcia roku',
  'ap.yearEnd.step.summary': 'Podsumowanie',
  'ap.yearEnd.step.review': 'Wyjaśnienia',
  'ap.yearEnd.step.additions': 'Uzupełnienia',
  'ap.yearEnd.step.final': 'Zatwierdź',
  'ap.yearEnd.step.submission': 'Złożenie',
  'ap.yearEnd.summaryTitle': 'Sprawdziłem dane roczne',
  'ap.yearEnd.summaryText': 'Musisz zająć się tylko punktami, których nie da się pewnie wyjaśnić na podstawie danych w Plumme.',
  'ap.yearEnd.approved': 'Sprawdzone i w porządku',
  'ap.yearEnd.notApplicable': 'Nie dotyczy',
  'ap.yearEnd.needsYou': 'Wymaga obsługi',
  'ap.yearEnd.startReview': 'Obsłuż punkty ({{count}})',
  'ap.yearEnd.continueAdditions': 'Przejdź do uzupełnień',
  'ap.yearEnd.questionCount': 'Pozostałe punkty: {{total}}',
  'ap.yearEnd.startReviewGroups': 'Obsłuż grupy ({{count}})',
  'ap.yearEnd.groupCount': 'Pozostałe grupy: {{total}}',
  'ap.yearEnd.confirmReviewed': 'Sprawdziłem i potwierdzam',
  'ap.yearEnd.changeSomething': 'Muszę coś zmienić',
  'ap.yearEnd.openWorkArea': 'Otwórz właściwy obszar roboczy',
  'ap.yearEnd.askAboutThis': 'Zapytaj AI o to',
  'ap.yearEnd.handleCheck': 'Obsłuż',
  'ap.yearEnd.backToFlow': 'Wróć do zamknięcia roku',
  'ap.yearEnd.openAsPage': 'Otwórz jako osobną stronę',
  'ap.yearEnd.workAreaNote': 'Punkty kontrolne aktualizują się na podstawie tego, co robisz tutaj.',
  'ap.yearEnd.reviewDone': 'Wszystkie punkty kontrolne są wyjaśnione',
  'ap.yearEnd.reviewDoneText': 'Teraz sprawdzimy, czy masz inne informacje, których nie ma w Plumme.',
  'ap.yearEnd.completeness': 'Kontrola kompletności',
  'ap.yearEnd.anythingElse': 'Czy jest coś jeszcze do dodania?',
  'ap.yearEnd.anythingElseText': 'Opisz to własnymi słowami. AI pomoże znaleźć właściwy obszar, ale niczego nie zmieni, zanim nie sprawdzisz i nie zatwierdzisz propozycji.',
  'ap.yearEnd.additionPlaceholder': 'Na przykład: w grudniu kupiliśmy samochód dostawczy, ale faktura przyszła w styczniu.',
  'ap.yearEnd.findAddition': 'Znajdź właściwe uzupełnienie',
  'ap.yearEnd.showAllAdditions': 'Pokaż wszystkie uzupełnienia',
  'ap.yearEnd.noMore': 'Nie, nie mam nic więcej do dodania',
  'ap.yearEnd.finalControl': 'Kontrola końcowa',
  'ap.yearEnd.readyTitle': 'Zamknięcie roku jest gotowe do zatwierdzenia',
  'ap.yearEnd.result': 'Wynik za rok',
  'ap.yearEnd.backToReview': 'Obsłuż pozostałe punkty',
  'ap.yearEnd.completeAdditions': 'Zakończ kontrolę uzupełnień',
  'ap.yearEnd.closeYear': 'Zatwierdź i zamknij rok obrotowy',
  'ap.yearEnd.closing': 'Zamykanie …',
  'ap.yearEnd.closedToast': 'Rok obrotowy został zamknięty.',
  'ap.yearEnd.saveError': 'Nie udało się zapisać zamknięcia roku.',
  'ap.yearEnd.closeError': 'Nie udało się zamknąć roku obrotowego.',
  'ap.yearEnd.submissionTitle': 'Rok obrotowy jest zamknięty',
  'ap.yearEnd.filedTitle': 'Zamknięcie roku zostało zakończone',
  'ap.yearEnd.submissionText': 'Przejdź do skattemelding i sprawozdania finansowego. Późniejsze zmiany wprowadza się na razie w pełnym widoku.',
  'ap.yearEnd.ai.title': 'Zapytaj SuperPlumma',
  'ap.yearEnd.ai.context': 'Rozmowa dotyczy tego zamknięcia roku i tego punktu kontrolnego.',
  'ap.yearEnd.ai.empty': 'Zapytaj, dlaczego punkt jest istotny, co oznacza dane pojęcie, albo opisz coś, czego Twoim zdaniem brakuje.',
  'ap.yearEnd.ai.placeholder': 'Co chcesz wiedzieć?',
  'ap.yearEnd.ai.ask': 'Zapytaj',
  'ap.yearEnd.ai.thinking': 'Sprawdzanie …',
  'ap.yearEnd.ai.error': 'Nie udało się teraz pobrać wyjaśnienia.',
  'ap.yearEnd.ai.noAnswer': 'Nie znalazłem pewnej odpowiedzi. Otwórz pełny widok, aby sprawdzić to ręcznie.',
  'ap.yearEnd.ai.proposalTitle': 'Propozycja pozycji podatkowej',
  'ap.yearEnd.ai.assetGroup': 'Grupa amortyzacji podatkowej (saldogruppe)',
  'ap.yearEnd.ai.description': 'Opis',
  'ap.yearEnd.ai.openingValue': 'Wartość początkowa',
  'ap.yearEnd.ai.acquisition': 'Nowy zakup',
  'ap.yearEnd.ai.improvement': 'Ulepszenie',
  'ap.yearEnd.ai.proceeds': 'Przychód ze zbycia',
  'ap.yearEnd.ai.depreciation': 'Amortyzacja',
  'ap.yearEnd.ai.amount': 'Kwota',
  'ap.yearEnd.ai.bookPrevious': 'Wartość księgowa w zeszłym roku',
  'ap.yearEnd.ai.taxPrevious': 'Wartość podatkowa w zeszłym roku',
  'ap.yearEnd.ai.bookCurrent': 'Wartość księgowa w tym roku',
  'ap.yearEnd.ai.taxCurrent': 'Wartość podatkowa w tym roku',
  'ap.yearEnd.ai.approvalNote': 'Nic nie zostanie zapisane, zanim nie zatwierdzisz. Pozycja jest ponownie weryfikowana przy zapisie.',
  'ap.yearEnd.ai.approve': 'Zatwierdź i dodaj',
  'ap.yearEnd.ai.saved': 'Pozycja podatkowa została dodana do szkicu. Możesz opisać kolejne informacje, jeśli czegoś jeszcze brakuje.',
  'ap.yearEnd.ai.savedToast': 'Dodano pozycję podatkową',
  'ap.yearEnd.ai.saveError': 'Nie udało się zapisać pozycji podatkowej.',
  'ap.yearEnd.ai.draftInProgress': 'Propozycja w toku',
  'ap.yearEnd.ai.cancelDraft': 'Zakończ',
  'ap.agentName.bookkeeping': 'Agent księgowania',
  'ap.agentName.tax': 'Agent podatkowy',
  'ap.agentName.annual': 'Agent sprawozdania finansowego',
  'ap.followup.bank': 'Uzgodnienie bankowe',
  'ap.followup.title': 'Działania następcze',
  'ap.followup.countOne': 'Punkty wymagające działania: {{count}}.',
  'ap.followup.countMany': 'Punkty wymagające działania: {{count}}.',
  'ap.agent.tax.titleMissing': 'Brakujące warunki przed skattemelding: {{count}}',
  'ap.agent.annual.titleMissing': 'Brakujące warunki przed sprawozdaniem finansowym: {{count}}',
  'ap.readiness.yearOpen': 'Rok obrotowy nie jest zamknięty',
  'ap.readiness.yearOpenSub': 'Zamknięcie roku nie zostało przeprowadzone',
  'ap.readiness.inbox': 'Nieobsłużone dowody księgowe: {{count}}',
  'ap.readiness.inboxSub': 'Dokończ skrzynkę odbiorczą przed złożeniem rocznym',
  'ap.readiness.bank': 'Nieuzgodnione linie bankowe: {{count}}',
  'ap.readiness.bankSub': 'Dokończ uzgodnienie bankowe',
  'ap.readiness.previousTax': 'Nie potwierdzono złożenia poprzedniej skattemelding',
  'ap.readiness.reviewYear': 'Sprawdź {{year}}',
  'ap.review.all': 'Wszystkie',
  'ap.review.withVoucher': 'Z dokumentem',
  'ap.review.matched': 'Dopasowane',
  'ap.review.missingVoucher': 'Brak dokumentu',
  'ap.review.needsChecking': 'Wymaga sprawdzenia',
  'ap.review.createsDeviation': 'Powoduje rozbieżność',
  'ap.review.upToDate': 'Na bieżąco',
  'ap.review.approvedNotPosted': 'Zatwierdzone · niezaksięgowane',
  'ap.review.blocked': 'Zablokowane',
  'ap.review.ready': 'Gotowe',
  'ap.review.yourAccounts': 'Twoja księgowość',
  'ap.review.exampleData': 'Przykładowe dane',
  'ap.review.voucherLinked': '✓ Dokument powiązany',
  'ap.review.hideVoucher': 'Ukryj dokument',
  'ap.review.showVoucher': 'Pokaż dokument',
  'ap.review.allVouchersLinked': 'Wszystkie dokumenty są powiązane 🎉',
  'ap.review.deadline': 'Termin',
  'ap.review.readyForApproval': 'Gotowe do zatwierdzenia',
  'ap.surface.fullscreen': 'Pokaż na pełnym ekranie',
  'ap.surface.exitFullscreen': 'Zamknij pełny ekran',
  'ap.surface.voucherCount': 'Dokumenty: {{count}}',
  'ap.surface.outsideMonth': 'Poza miesiącem: {{count}}',
  'ap.surface.accountsAndVouchers': 'Konta i dokumenty bez linii bankowej',
  'ap.yearEnd.bank.title': 'Uzgodnienie bankowe {{year}}',
  'ap.yearEnd.bank.note': 'Wybierz miesiąc do sprawdzenia w ramach tego zamknięcia roku.',
  'ap.yearEnd.bank.openLines': 'Otwarte linie bankowe: {{count}}',
  'ap.yearEnd.bank.missingStatements': 'Konta bankowe bez wyciągu: {{count}}',
  'ap.yearEnd.bank.done': 'Uzgodnione i zarchiwizowane',
  'ap.yearEnd.bank.needsArchive': 'Sprawdź archiwizację',
  'ap.yearEnd.bank.noStatement': 'Brak wyciągu bankowego',
  'ap.yearEnd.backToWorkArea': 'Wróć do: {{title}}',
  'ap.surface.bankUploadUnavailable': 'Przesyłanie wyciągów bankowych nie jest jeszcze dostępne.',
  'ap.surface.bankReadError': 'Nie udało się odczytać wyciągu bankowego.',
  'ap.surface.bankLoadErrorTitle': 'Nie udało się wczytać uzgodnienia',
  'ap.surface.bankLoadErrorDetail': 'Odśwież stronę lub otwórz wyciąg z sekcji Bank.',
  'ap.surface.assetMovedToExpense': 'Dokument został wyłączony z kontroli środków trwałych. Sprawdź konto i VAT na liście księgowań.',
  'ap.surface.assetSkipError': 'Nie udało się pominąć rejestracji środka trwałego.',
  'ap.surface.assetTitle': 'Możliwe środki trwałe',
  'ap.surface.assetSubtitle': 'Dokumenty powyżej progu kwotowego: {{count}}',
  'ap.surface.assetEmptyTitle': 'Brak kolejnych propozycji środków trwałych',
  'ap.surface.assetChooseHelp': 'Wybierz, czy dokument ma zostać zarejestrowany jako środek trwały, czy odesłany do zwykłej kontroli księgowej. Zakup jest księgowany tylko raz.',
  'ap.surface.assetNotAsset': 'To nie jest środek trwały',
  'ap.surface.inboxTitle': 'Skrzynka odbiorcza dokumentów',
});
